import "./art_carousel.scss";

import * as types from "@root/types";
import React, { FC } from "react";
import Modal from "react-modal";

import { ArtCarousel } from "./art_carousel";

interface ArtModalModalProps {
  artPieces: types.ArtPiece[];
  initialIdx: number;
  isOpen: boolean;
  close: () => void;
}

const setAppElement = Modal.setAppElement;

const ArtModalModal: FC<ArtModalModalProps> = ({
  artPieces,
  initialIdx,
  isOpen,
  close,
}) => {
  setAppElement("body");

  const customStyles = {
    overlay: {},
  };

  return (
    <div>
      <Modal
        className="art-modal"
        isOpen={isOpen}
        style={customStyles}
        onRequestClose={close}
      >
        <ArtCarousel
          artPieces={artPieces}
          initialIdx={initialIdx}
          close={close}
        />
      </Modal>
    </div>
  );
};

export { ArtModalModal, ArtModalModalProps };
